import { render } from "./RequiredField.vue?vue&type=template&id=645c2311"
import script from "./RequiredField.vue?vue&type=script&lang=js"
export * from "./RequiredField.vue?vue&type=script&lang=js"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__